import script from "./AppDock.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDock.vue?vue&type=script&setup=true&lang=js"

import "./AppDock.vue?vue&type=style&index=0&id=3680112a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3680112a"]])

export default __exports__